export default "__VITE_ASSET__XfCB7xMM__"